/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const VerifyBusiness = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 18 16">
      <path
        d="M1 2V0H17V2H1ZM1 16V10H0V8L1 3H17L18 8V10H17V16H15V10H11V16H1ZM3 14H9V10H3V14ZM2.05 8H15.95L15.35 5H2.65L2.05 8Z"
        fill={props?.color || "white"}
      />
    </BaseSvgIcon>
  )
}

export default VerifyBusiness
